import { z } from "zod";
import { AddressFields } from "../common/address.js";
import { CountryCode } from "../common/country.js";
import { Id } from "../common/ids.js";
import { LocalizedText } from "../common/localized-text.js";
/** What inquiries, quotes, and orders share (cards 052 to 054). */
export const Incoterm = z
    .enum(["EXW", "FCA", "CPT", "CIP", "DAP", "DPU", "DDP", "FAS", "FOB", "CFR", "CIF"])
    .meta({ id: "Incoterm", description: "Incoterms 2020" });
export const TradeSide = z.enum(["buyer", "seller"]).meta({ id: "TradeSide" });
/** The two parties as they were named when the inquiry was made. */
export const TradeParties = {
    shop: z.object({ id: Id, name: LocalizedText }),
    buyer: z.object({ enterpriseId: Id, name: LocalizedText }),
};
/** An address from an enterprise's address book as it was when a quote or an order took it; it never changes after. */
export const TradeAddress = z
    .object({
    label: z.string(),
    country: CountryCode,
    fields: AddressFields,
    contactName: z.string().nullable(),
    contactPhone: z.string().nullable(),
})
    .meta({ id: "TradeAddress" });
export const HsCode = z
    .string()
    .regex(/^\d{6,10}$/)
    .describe("The Harmonized System code, 6 to 10 digits");
//# sourceMappingURL=terms.js.map